import { styled } from "styled-components";

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  color?: string;
}
export const WrapperButton = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding: 0 10px;
`;
export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  border-radius: 99px;
  padding: 10px;
  font-size: 12px;
  text-transform: uppercase;
  font-family: "Archivo-Regular";
  color: ${(props) => props.color || "#fff"};
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;

export const WrapperCheckbox = styled.div`
  width: 100%;
  padding: 2.5rem 15px;
  @media (max-width: 426px) {
    gap: 20px;
    padding: 0 0 40px 0;
  }
`;

export const TitleModal = styled.h1`
  color: #2c2c2c;
  text-align: center;
  font-size: 28px;
  @media (max-width: 426px) {
    font-size: 22px;
    margin-bottom: 15px;
  }
`;

export const InfoInputs = styled.p`
  text-align: center;
  margin-top: 4px;
  background: #ECEEF0;
  border-radius: 8px;
  padding: 4px;
  color: #2c2c2c;
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
export const RequiredMessage = styled.span`
  padding: 0;
  color: red;
  font-size: 12px;
`;
